import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AlertService } from 'src/app/_helpers/alert.service';
import { AuthService } from 'src/app/_services/auth.service';

import { MustMatch } from 'src/app//_helpers/must-match.validator';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordComponent implements OnInit {

  readOnlyField: boolean = false;
  otpValidated: boolean = false;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;
  showLoader: boolean = false;

  @ViewChild('resetPasswordNgForm') resetPasswordNgForm!: NgForm;
  resetPasswordForm: FormGroup = this._formBuilder.group({
    otp  : ['', [
      Validators.required
    ]],
    newPassword  : ['', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(15),
    ]],
    confirmNewPassword: ['', [
      Validators.required
    ]]
  }, {
    validator: MustMatch('newPassword', 'confirmNewPassword')
  });

  constructor(
    private _title: Title,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _alertService: AlertService,
    private _authService: AuthService,
  ) {
    this._title.setTitle('Reset Password');
  }

  ngOnInit(): void {
    
  }

  onSubmit(): void {
    if(!this.otpValidated) {
      this.validateToken();
    } else {
      this.resetPassword();
    }
  }

  validateToken(): void {
    if(this.resetPasswordForm.value.otp) {
      // this.readOnlyField = false;
      // this.otpValidated = false;
      const otp = this.resetPasswordForm.value.otp;
      this.showLoader = true;
      this._authService.validatePasswordResetToken(otp).subscribe({
        next: (response: any) => {
          this.showLoader = false;
          const { isSuccess, message } = response;
          if(isSuccess) {
            this.readOnlyField = true;
            this.otpValidated = true;
            this.resetPasswordNgForm.resetForm();
            this.resetPasswordForm.patchValue({
              otp: otp
            });
          } else {
            this._alertService.show_alert(message, '' , 'error');
          }
        },
        error: (errorResponse: any) => {
          this.showLoader = false;
          this._alertService.show_alert(errorResponse?.message, '' , 'error');
        }
      });
    }
    return;
  }

  resetPassword(): void {
    // Return if the form is invalid
    if (this.resetPasswordForm?.invalid) {
      return;
    }

    const formData = {
      token: this.resetPasswordForm.value.otp,
      newPassword: this.resetPasswordForm.value.newPassword,
    }

    this.showLoader = true;
    this._authService.resetPassword(formData).subscribe({
      next: (response: any) => {
        this.showLoader = false;
        const { isSuccess, message } = response;
        if(isSuccess) {
          this._alertService.show_alert(message);
          this._router.navigate(['/login']);
        } else {
          this._alertService.show_alert(message, '', 'error');
        }
      },
      error: (errorResponse) => {
        this.showLoader = false;
        this._alertService.show_alert(errorResponse?.message, '', 'error');
      }
    });
  }

}
